import { formatEnumName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeEnumStmtInstruction = `
#### Deleting enum
- Syntax: \`remove enum <enum_name>;\`
- Example: \`remove enum orderStatus;\``;
export const stmtRemoveEnum = ({ enumName }) => {
    return `remove enum ${enumName};`;
};
export const stmtForHumanRemoveEnum = ({ enumName }) => {
    return `Delete the enum __${enumName}__.`;
};
export const removeEnumHandler = createSchemaStatementHandler({
    type: 'remove enum',
    parse: line => {
        const match = /^remove enum (?<enumName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove enum',
                enumName: formatEnumName(match.groups.enumName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemoveEnum,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            return it.removeEnum(stmt.enumName);
        });
    },
});
//# sourceMappingURL=RemoveEnumStmt.js.map